import gql from "graphql-tag";

export const GET_BATCH_CONTENTS_PROGRESS_BREAKDOWN = gql`
  query GET_BATCH_CONTENTS_PROGRESS_BREAKDOWN($batchId: ID!) {
    batchCompaniesContentProgressBreakdown(batchId: $batchId)
  }
`;
